var canvas, canvas2,text,fontSize, fontFamily, fSize, activeCOLOR, newText, zoom, cWidth = 2000, cHeight = 2000,
    halfWidth = cWidth / 2, halfHeight = cHeight / 2,
    obj, array = [], get_data, sizeCrop,
    scale_factor, newheight, leftOb, imageUrl,img,
    leftMarker, rightMarker, vLine;

var loader = jQuery('#customLoader'),
    cropper = "", canvas, boxWidth, boxLeft, boxTop,
    croppedSize, orientations, aspectRatio, reCroper,
    c1img1;


imageUrl = document.getElementById('imageContainer').getAttribute('data-image-url');



window['canvas2'] = new fabric.Canvas('canvas2', {
  width: cWidth,
  height: cHeight
});

addModify(window['canvas2']);




$(document).ready(function () {
  let currentImage = null;

  function loadImage(url) {
    if (currentImage) {
      canvas2.remove(currentImage);
    }

    fabric.Image.fromURL(
      url,
      function (img) {
        img.set({
          left: halfWidth,
          top: halfHeight,
          selectable: false
        });

        img.scale(1);
        canvas2.add(img);
        canvas2.sendToBack(img);
        currentImage = img;

        canvas2.renderAll();
      },
      { crossOrigin: 'anonymous' }
    );
  }

  function setActiveBackground($btn) {
  // UI ✔
  $('#background_design a').removeClass('active');
  $btn.addClass('active');

  // Load image
  const url = $btn.find('img').attr('data-src');
  if (url) loadImage(url);

  // Cart value
  backgroundDesign = $btn.data('title');

  // 🔥 APPLY TEXT COLOR ONLY HERE
  syncTextColorFromBackground($btn);
}


  // =====================
  // DEFAULT LOAD
  // =====================
  const $defaultBtn = $('#icon1');
  setActiveBackground($defaultBtn);

  // =====================
  // CLICK HANDLER
  // =====================
  $('#background_design').on('click', 'a', function (e) {
    e.preventDefault();
    setActiveBackground($(this));
  });
});





fabric.Text.prototype.textBaseline = 'alphabetic';


function applyEmbossShadow(textObj, mode) {
  if (!textObj) return;

  const shadowColor = (mode === "dark")
    ? "rgba(0, 0, 0, 0.51)"
    : "rgba(0, 0, 0, 0.37)";

  textObj.set({
    shadow: new fabric.Shadow({
      color: shadowColor,
      blur: 0,
      offsetX: 7,
      offsetY: 7
    })
  });
}




function createGoldTextGradient(textObj) {
  textObj.initDimensions(); // 🔥 required

  return new fabric.Gradient({
    type: 'linear',
    gradientUnits: 'pixels',
    coords: {
      x1: 0,
      y1: 0,
      x2: 0,
      y2: textObj.height
    },
    colorStops: [
      { offset: 0.0, color: '#e7bc6e' },
      { offset: 0.25, color: '#efde98' },
      { offset: 0.55, color: '#e8d08a' },
      { offset: 0.75, color: '#e3b262' },
      { offset: 1.0, color: '#efd186' }
    ]
  });
}



function applyFontColorByClass(colorClass) {
  if (!window.text2Page) return;

  window.text2Page.initDimensions();

  if (colorClass === "golden") {
    window.text2Page.set({
      fill: createGoldTextGradient(window.text2Page)
    });
    applyEmbossShadow(window.text2Page, "dark");
  }

  if (colorClass === "white") {
    window.text2Page.set({
      fill: "#eeeeee",
      shadow: new fabric.Shadow({
        color: "rgba(0, 0, 0, 0.51)",
        blur: 6,
        offsetX: 7,
        offsetY: 7
      })
    });
  }

  if (colorClass === "black") {
    window.text2Page.set({
      fill: "#000",
      shadow: new fabric.Shadow({
        color: "rgba(0, 0, 0, 0.62)",
        blur: 6,
        offsetX: 7,
        offsetY: 7
      })
    });
  }

  canvas2.renderAll();
}



function syncTextColorFromBackground($btn) {
  if ($btn.hasClass('goldenColor')) {
    applyFontColorByClass("golden");
    $('#selected_font_color').val('Golden');
  }

  if ($btn.hasClass('whiteColor')) {
    applyFontColorByClass("white");
    $('#selected_font_color').val('White');
  }

  if ($btn.hasClass('blackColor')) {
    applyFontColorByClass("black");
    $('#selected_font_color').val('Black');
  }
}







window['text2Page'] = new fabric.Text('check',{
  left: 1000,
  top: 980,
  fontSize: 280,
  fontFamily: 'Galada',
  textBaseline: 'alphabetic',
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false,
  textAlign: 'center',
  isWrapping: true,
  fill: '#e5e5e5'
});

var fontName = window['text2Page'].fontFamily;
jQuery('.choose_font2').val("'" + fontName + "'").trigger('change');



window.text2Page.set({
  fill: createGoldTextGradient(window.text2Page)
});
applyEmbossShadow(window.text2Page, "dark");

canvas2.add(window.text2Page);
canvas2.renderAll();


// Clear text on input focus if default
document.getElementById('text_2').addEventListener('focus', function () {
  if (window['text2Page'].text === 'Shaheer') {
    window['text2Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});



function fitTextToWidth2(textObj, maxWidth) {
  let fontSize = 300; 
  textObj.set({ fontSize });


  while (textObj.width > maxWidth && fontSize > 5) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

document.getElementById('text_2').addEventListener('input', function (e) {
  const newText = e.target.value;
  window['text2Page'].set('text', newText);
  fitTextToWidth2(window['text2Page'], 1300);
  window['text2Page'].bringToFront();
  const $activeBg = $('#background_design a.active');
  if ($activeBg.length) {
    syncTextColorFromBackground($activeBg);
  }
  window['canvas2'].renderAll();
});



const $defaultBg = $('#icon1'); // Pink Gold
$defaultBg.addClass('active');

syncTextColorFromBackground($defaultBg);







function canvasMakeImg(canvas,zoom){
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function canvasBlock(canvas){
  zoom = jQuery('.product__media-outer').width();
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function setZoomMask(canvas,newZoomLevel){
  canvas.setZoom(newZoomLevel);
  canvas.setDimensions({
    width:  cWidth * newZoomLevel,
    height:  cHeight * newZoomLevel
  });
  canvas.renderAll();
}

function addModify(canvas){
  fabric.Object.prototype.transparentCorners = false;
  fabric.textureSize = 75497472;

  canvas.renderOnAddRemove = false;
  canvas.on('selection:cleared', function(e){
    object = e.target;
  });

  canvas.on('object:removed',function(e){
    object = e.target;
  });

  canvas.on('object:added', function(e){
    object = e.target;
    addControls(object);
    canvas.renderAll();
  });
  
  canvas.on('object:modified', function(e){
    object = e.target;
    canvas.renderAll();
  });
  
  canvas.on('selection:created', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('selection:updated', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('object:scaling', function(e){
    canvas.renderAll();
  });

}

// jQuery(window).on('load',function(){
  //   canvasBlock(canvas);
  //   loadFirstImg();
  // });

  jQuery(window).on('resize',function(){
    canvasBlock(window['canvas2']);
  });

function addControls(object){
  var iconTL = document.createElement("img"),
      iconBR = document.createElement("img");
  
  iconTL.src = trashIcon;
  iconBR.src = resizeIcon;
  
  object.set({
    selectable:false,
    originX:"center",
    originY:"center",
    transparentCorners: false,
    borderColor: '#ddd',
    borderDashArray: [6,2],
    cornerStyle: 'circle',
    cornerColor: '#fff',
    objectCaching: false,
    _controlsVisibility: {
      tr: false,
      tl: true,
      bl: false,
      br: true,
      mb: false,
      ml: false,
      mr: false,
      mt: false,
      mtr: false
    }
  });
  
  iconTL.onload = function() {
    fabric.Object.prototype.controls.tl = new fabric.Control({
      x: -0.5,
      y: -0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "pointer",
      mouseUpHandler: deleteHandler,
      render: renderIcon(iconTL),
      withConnection: true,
      cornerSize: 18,
    });
  };
  iconBR.onload = function() {
    fabric.Object.prototype.controls.br = new fabric.Control({
      x: 0.5,
      y: 0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "se-resize",
      mouseUpHandler:fabric.controlsUtils.scalingEqually,
      render: renderIcon(iconBR),
      withConnection: true,
      cornerSize: 18,
    });
  }
}

function renderIcon(icon) {
  return function (ctx, left, top, styleOverride, fabricObject) {
    const size = this.cornerSize;
    ctx.save();
    ctx.translate(left, top);
    ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
    ctx.drawImage(icon, -size / 2, -size / 2, size, size);
    ctx.restore();
  };
}

function deleteHandler(eventData,transform){
  var target = transform.target;
  activeOb = canvas.getActiveObject();
  canvas.remove(activeOb);
  canvas.renderAll();
}

initCropper();

function readURL2(input){
  loader.removeClass('hidden');
  jQuery('#tadaWidget').addClass('hidden');
  if(cropper == ""){
  }else {
    cropper.destroy();
  }
  if (input.files && input.files[0]) {
    var reader = new FileReader();
    reader.onload = function (e) {
      jQuery('#blah').attr('src', e.target.result);
      reCroper.attr('data-img',e.target.result);
    };
    reader.readAsDataURL(input.files[0]);
    setTimeout(initCropper, 2500);
  }
}

function addImage(e,placeholderimg,canvas){
  var file = e.target.files[0];
  var reader = new FileReader();
  reader.onload = function(event){
    var imgObj = new Image();
    imgObj.src = event.target.result;
    imgObj.onload = function(){
      var img = new fabric.Image(imgObj);
      img.set({
        left: placeholderimg.left,
        top: placeholderimg.top,
        selectable:true,
        scaleX: placeholderimg.width / img.width,
        scaleY: placeholderimg.height / img.height,
      });
      canvas.add(img);
    };
  };
  reader.readAsDataURL(file);
}

function addCroppedImg(imgurl){
  canvas.remove(img).renderAll();
  fabric.Image.fromURL(imgurl, function(newImg){
    newImg.set({
      left: img.left,
      top: img.top,
      selectable: img.selectable
    });
    newImg.scaleToHeight(available_height);
    canvas.add(newImg).renderAll();
    img = newImg;
    canvas.renderAll();
  });
}

function initCropper(){
  var image = document.getElementById('blah');
  cropper = new Cropper(image, {
    viewMode: 1,
    dragMode: 'move',
    aspectRatio: sizeCrop,
    restore: false,
    guides: false,
    center: true,
    highlight: true,
    cropBoxMovable: true,
    cropBoxResizable: true,
    toggleDragModeOnDblclick: false,
    data:{}
  });
  jQuery('.popupImg').show();
  jQuery('#tadaWidget').addClass('hidden');
  loader.addClass('hidden');
}

document.getElementById('crop_button').addEventListener('click', function(){
  loader.removeClass('hidden');
  jQuery('#tadaWidget').addClass('hidden');
  var imgurl =  cropper.getCroppedCanvas().toDataURL();
  addCroppedImg(imgurl);
  setTimeout(function(){
    reCroper.parent().removeClass('hidden');
    jQuery('.popupImg').hide();
    loader.addClass('hidden');
    jQuery('#tadaWidget').removeClass('hidden');
  },500);
});

document.getElementById('zoom_out').addEventListener('click', function(){
  cropper.zoom(-0.1);
});

document.getElementById('zoom_in').addEventListener('click', function(){
  cropper.zoom(0.1);
});

document.getElementById('reset_button').addEventListener('click', function(){
  cropper.reset();
});

document.getElementById('cancelCropper').addEventListener('click', function(){
  jQuery('.popupImg').hide();
  jQuery('#tadaWidget').removeClass('hidden');
});

jQuery(document).on('click','.btnReCrop', function(){
  loader.removeClass('hidden');
  imgurl = jQuery(this).attr('data-img');
  sizeCrop = jQuery(this).attr('data-ratio');
  img = window[jQuery(this).attr('data-obj')];
  canvas = window[jQuery(this).attr('data-canvas')];
  available_height = jQuery(this).attr('data-height');
  console.log(canvas);
  jQuery('#tadaWidget').addClass('hidden');
  setTimeout(function(){
    cropper.destroy();
    jQuery('#blah').attr('src',imgurl);
    initCropper();
    jQuery('.popupImg').show();
    loader.addClass('hidden');
  },150);
});

jQuery('.customColors').each(function(){
  colorBox = jQuery(this).attr('id');
  loadColorPicker(colorBox);
});

jQuery(document).on('change', '.fontFamily', function () {
  const fontID = jQuery(this).attr('data-canvas');
  const textObID = jQuery(this).attr('data-obj');

  const canvas = window[fontID];
  const textObj = window[textObID];

  if (!textObj) return;

  // 🔥 change font
  textObj.set({
    fontFamily: this.value,
    scaleX: 1,
    scaleY: 1
  });

  // 🔥 force recalculation
  textObj.initDimensions();
  textObj.setCoords();

  // 🔥 refit text box
  fitTextToWidth2(window['text2Page'], 1300);

  // 🔥 keep selected color (gradient / solid)
  const $activeBg = $('#background_design a.active');
if ($activeBg.length) {
  syncTextColorFromBackground($activeBg);
}


  canvas.renderAll();
});



function loadColorPicker(colorBox){
  jQuery('#'+colorBox).colorpicker({
    inline: true,
    container: true,
    extensions:[{
      name: 'swatches',
      options:{
        colors:{
          'tetrad1': 'transparent',
          'tetrad2': '#e30405',
          'tetrad3': '#197b30',
          'tetrad4': '#0054a5',
          'tetrad5': '#ffcc00',
          'tetrad6': '#f6ebbe',
          'tetrad7': '#ffea00',
          'tetrad8': '#f8931d',
          'tetrad9': '#f499c2',
          'tetrad10': '#959595',
          'tetrad11': '#fef335',
          'tetrad12': '#a0400d',
          'tetrad13': '#000000',
          'tetrad14': '#604973',
          'tetrad15': '#afe8fc',
          'tetrad16': '#fffafa',
          'tetrad17': '#bc8cbe',
          'tetrad18': '#ff69b4',
          'tetrad19': '#93278f',
          'tetrad20': '#009987',
          'tetrad21': '#0af447',
          'tetrad22': '#00008b',
          'tetrad23': '#006400'
        },
        namesAsValues: false
      }
    }],
    template: '<div class="colorpicker">' +
      '<div class="colorpicker-saturation"><i class="colorpicker-guide"></i></div>' +
      '<div class="colorpicker-hue"><i class="colorpicker-guide"></i></div>' +
      '<div class="colorpicker-alpha">' +
      '   <div class="colorpicker-alpha-color"></div>' +
      '   <i class="colorpicker-guide"></i>' +
      '</div>' +
      '<div class="colorpicker-bar">' +
      '   <a href="javascript:void(0);" class="button btn-block colorOFF">Ok</a>'+
      '   <div class="ctn-icon-eyedropper dropper-eyedrop"><svg class="icon icon-eyedropper" viewBox="0 0 16 16">'+
      '   <path d="M13.354.646a1.207 1.207 0 0 0-1.708 0L8.5 3.793l-.646-.647a.5.5 0 1 0-.708.708L8.293 5l-7.147 7.146A.5.5 0 0 0 1 12.5v1.793l-.854.853a.5.5'+
      '   0 1 0 .708.707L1.707 15H3.5a.5.5 0 0 0 .354-.146L11 7.707l1.146 1.147a.5.5 0 0 0 .708-.708l-.647-.646 3.147-3.146a1.207'+
      '   1.207 0 0 0 0-1.708zM2 12.707l7-7L10.293 7l-7 7H2z"/></svg></div>'+
      '</div>' +
      '</div>'
  }).on('colorpickerCreate', function(){
    var colorBox = jQuery(this);
    setTimeout(function(){
      var colorID = colorBox.attr('id'),
        active = colorBox.find('.currentColor'),
        activeCOLOR = active.attr('value');
      colorBox.find('.colorBox').attr('style','background:'+activeCOLOR+';');
    },200);
  }).on('colorpickerChange', function(){
    var colorBox = jQuery(this);
    setTimeout(function(){
      var colorID = colorBox.attr('data-canvas'),
          textOb = colorBox.attr('data-obj'),
          active = colorBox.find('.currentColor'),
          activeCOLOR = active.attr('value');
      colorBox.find('.colorBox').attr('style','background:'+activeCOLOR+';');
      colorBox.attr('data-color',activeCOLOR);
      canvas = window[colorID];
      activeOb = window[textOb];
      sCAle = activeOb.scaleX;
      activeOb.set('fill',activeCOLOR);
      activeOb.scaleX = .5;
      activeOb.setCoords();
      canvas.renderAll();
      activeOb.scaleX = sCAle;
      activeOb.setCoords();
      canvas.renderAll();
    },200);
  });
  jQuery(document).on('click','.colorBox',function(){
    jQuery('.colorBox').each(function(){
      jQuery(this).next().hide();
    });
    jQuery(this).next().show();
  });
  jQuery(document).on('click','.colorOFF',function(){
    var parENt = jQuery(this).parent().parent(),
        toolBarBox = parENt.parent().parent().parent().attr('id');
    if(toolBarBox === 'labelBase'){
      parENt.parent().parent().parent().parent().removeClass('active');
    }else{
      parENt.hide();
    }
  });
}



jQuery(document).on('click','.dropper-eyedrop',function(){
  const eyeDropper = new EyeDropper();
  eyeDropper.open().then(result => {
    jQuery(this).parent().parent().parent().colorpicker('setValue', result.sRGBHex);
  }).catch(e => {
    console.error(e);
  });
});




jQuery(window).on('load',function(){
  canvasBlock(canvas2);
  window['text2Page'].set('text','Shaheer');
  window['canvas2'].renderAll();
  // loadFirstImg();
});


function getCookie(name){
  let nameEQ = name + "=";
  let cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++){
    let cookie = cookies[i].trim();
    if(cookie.indexOf(nameEQ) === 0){
      return cookie.substring(nameEQ.length, cookie.length);
    }
  }
  return null;
}

window.addEventListener("load", function(){
  if(getCookie("firstVisit")){
    console.log("✅ Cookie exists:", getCookie("firstVisit"));
  } else{
    console.log("❌ Cookie does not exist!");
    document.cookie = "firstVisit=textresizing; expires=" + new Date(Date.now() + 24 * 60 * 60 * 1000).toUTCString() + "; path=/;";
    location.reload();
  }
});



/* fetch Call */
// var size,thumbnail;
var loadedObject,backgroundDesign,enterQuote,Font2,additionalInfo,frameColor, wMark,svgMrk;
let pdfData = {};
jQuery(document).on('click','#download',function(){
  loader.removeClass('hidden');
  setTimeout(function(){
    const id = ['canvas2'];
    const canvas = window['canvas2'];
    size = 350;
    loadMark(id,canvas,size);
    size = 4000;
    removeMark(canvas,size);
    window['canvas2'] = canvas.toDataURL('image/png');
    backgroundDesign = backgroundDesign;
    enterQuote = jQuery('.enter_quote input').val();
    Font2 = jQuery('.choose_font2 option:selected').val();
    additionalInfo = jQuery('.tShirtImg textarea').val();
    canvasBlock(canvas);
    console.log(window['canvas2']);
    fetch('//technology-architects.com/tasweer-modules/save_order.php',{
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body:  JSON.stringify({
        temp_image: window['canvas2t'],
        original_image: window['canvas2']
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log(data);
      var previewId = data[0],
          extraImg1 = data[1];
      jQuery('#previewImg').val(previewId);
      jQuery('#preExtraImg').val(extraImg1);
      jQuery('#backgroundDesign').val(backgroundDesign);
      jQuery('#enterQuote').val(enterQuote);
      jQuery('#Font2').val(Font2);
      jQuery('#addInfo').val(additionalInfo);
      //console.log('Server response:', data);
      jQuery('.product-form__buttons .product-form__submit').trigger('click');
      handleUpload(fileInputs,previewId);
    })
    .catch(error => console.error('Error uploading images:', error));
  },100);
});

function loadMark(id,canvas,size){
  wMark = document.getElementById('wm_collage');
  svgMrk = wMark.innerHTML;
  fabric.loadSVGFromString(svgMrk, function(objects,options){
    loadedObject = fabric.util.groupSVGElements(objects, options);
    loadedObject.scaleToWidth(cWidth);
    loadedObject.set({
      left: cWidth / 2,
      top: cHeight / 2,
      originX: 'center',
      originY: 'center',
      objectCaching: false,
      selectable: false
    });
    canvas.add(loadedObject);
    loadedObject.bringToFront();
    loadedObject.setCoords();
    canvas.renderAll();
  });
  canvasMakeImg(canvas,size);
  window[id+'t'] = canvas.toDataURL('image/png');
  console.log(window[id+'t']);
}

function removeMark(canvas,size){
  canvas.remove(loadedObject).renderAll();
  canvasMakeImg(canvas,size);
}